const getThemesState = (state: GlobalState) => state.themes;
const getCurrentTheme = (state: GlobalState) => getThemesState(state).current;

export { getThemesState, getCurrentTheme };
